module.exports = __webpack_public_path__ + "h5/img/nodata.7db94b25.png";